import { Application } from "stimulus"
import TpayWalletController from "../controllers/tpay_wallet_controller"

const application = Application.start()
application.register("tpay-wallet", TpayWalletController)
